module.exports = __webpack_public_path__ + "img/hr-V-L-246-unload-standup-top.347919b9.png";